<template>
  <v-col cols="12" sm="6" :md="$slots.prepend ? 4 : 3">
    <v-card :outlined="!flat" :flat="flat" height="100%">
      <v-card-text :class="{ 'pa-0': flat }">
        <v-row>
          <v-col cols="auto">
            <slot name="prepend"> </slot>
          </v-col>
          <v-col :class="$slots.prepend ? '' : 'pa-0'">
            <div class="secondary--text font-weight-bold pb-4">
              {{ label }}
            </div>
            <template v-if="!hideValue">
              <anonymous-icon v-if="isAnonymous" :size="50"> </anonymous-icon>
              <v-icon v-else-if="value == emptyValue">remove</v-icon>
              <div
                v-else-if="value"
                class="text-h3 pb-2 d-flex"
                v-bind:style="{
                  color: color
                }"
              >
                <span>{{ value }}</span>
                <slot name="valueExtension"> </slot>
              </div>
            </template>
            <div>
              <slot> </slot>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import AnonymousIcon from "@/components/common/AnonymousIcon";
export default {
  name: "ReportOverallCard",
  components: { AnonymousIcon },
  props: {
    color: { type: String },
    value: { type: [Number, String] },
    label: { type: String },
    isAnonymous: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    emptyValue: { type: Number },
    hideValue: { type: Boolean, default: false }
  }
};
</script>
